/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2025, Zumper
 * @description useZoeMapListVariation hook
 */

import { OptimizelyContext } from '@optimizely/react-sdk'
import { useContext } from 'react'
import { ZOE_MAP_LIST } from './constants'

export const useZoeMapListVariation = (isCurrentSearchView?: boolean) => {
  const { optimizely } = useContext(OptimizelyContext)

  if (!optimizely || !isCurrentSearchView) {
    return
  }

  return optimizely?.activate(ZOE_MAP_LIST)
}
